"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.WebMessenger = void 0;
var _webMessengerContext = require("../../contexts/webMessengerContext");
var _Button = require("../Button");
var _jsxRuntime = require("react/jsx-runtime");
const WebMessenger = () => {
  const {
    deploymentId
  } = (0, _webMessengerContext.useWebMessenger)();
  return deploymentId ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_Button.Button, {}) : null;
};
exports.WebMessenger = WebMessenger;
